<template>
  <div>
    <div class="row">
      <div class="v-h"></div>
    </div>
    <div class="row cu-dir">
      <div class="col-md-12 d-h d-md-block"></div>
      <div class="col-md-6 q-margin">
        <!-- <div class="dir px-3 px-md-0 " v-if="loader" > -->
          <div class="dir px-3 px-md-0" >
          <div class="d-flex animate__fadeInDown" :style="`animation-delay:0.5s;transition: opacity 0.5s ease;`">
            <h4 class="title mb-4 font-weight-bold main-pic-title">{{sliderActive.title}}</h4>
          </div>

          <div class="d-flex animate__fadeInDown" :style="`animation-delay:1s;transition: opacity 0.5s ease;`">
            <h5 class="title mb-3 subtitle-color">{{sliderActive.description}}</h5>
          </div>

          <div class="d-flex justify-content-between flex-lg-column flex-wrap flex-lg-nowrap">
            <router-link :to="{name:'profile',params:{id:sliderActive.user.id}}" class="user d-flex align-items-center mb-3 animate__fadeInDown"
              :style="`animation-delay:1s`">
              <img :src="`https://pic.imamhussain.org/avatars/medium/${sliderActive.user.avatar}`" alt="user-avatar"
                style="width:60px !important;height:60px !important; object-fit: cover;">
              <h6 class="mx-3 f-s" style="font-size:larger">{{sliderActive.user.name}}</h6>
            </router-link>
            <div class="btn-group cu-btn-group rounded" role="group" style="height: 42px;width: 185px;">
              <button id="btnGroupDrop1" type="button" class="btn cursor btn-light" data-toggle="dropdown"
                aria-expanded="false">
                تحميل الصورة
                <img src="@/assets/down.svg" alt="download" height="20" class="mr-2 mb">
              </button>
              <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                <a class="dropdown-item text-right"
                  :href="`https://pic.imamhussain.org/index.php/photo/download/hd/${sliderActive.image}`">تحميل بدقة
                  عالية</a>
                <a class="dropdown-item text-right"
                  :href="`https://pic.imamhussain.org/index.php/photo/download/${sliderActive.image}`">تحميل بالحجم
                  الكامل</a>
              </div>
            </div>    
          </div>
        </div>
        <div class="d-flex d-photos mt-3 w-50" v-if="thumbs">
        <div v-for="(slide,index) in $store.state.gallery.todayPhoto" :key="index" class="m-1 cursor"
          @click="changeSlide(index)"
          :class="{'border-danger animate__animated animate__pulse':sliderActive.id ==slide.id}">
          <img :src="`https://pic.imamhussain.org/photos/main/${slide.file}`" alt="slide-file" class="d-photo rounder">
        </div>
      </div>
      </div>
      <div class="col-md-6">
        <div class="day-pic ">
          <router-link :to="{name: 'details',params: { id: sliderActive.id },query: {
              image: sliderActive.image,
              height: sliderActive.height,
              width: sliderActive.width,
              pres: (sliderActive.height / sliderActive.width) * 100,
            }}">
          <img v-if="todayImageInfo.width > todayImageInfo.height"
            :src="`https://pic.imamhussain.org/photos/hd/${sliderActive.file}`" alt="slider-image" class="shad"
            :width="todayImageInfo.width">
          <img v-if="todayImageInfo.width < todayImageInfo.height"
            :src="`https://pic.imamhussain.org/photos/hd/${sliderActive.file}`" alt="slider-image" class="shad"
            :height="todayImageInfo.height">
          </router-link>
        </div>
      </div>
      
      
      
    </div>
    <div class="marq mb-2 mt-5">
            <nav class="marquee_cont mt-md-4">
              <a href="#" class="marquee_item grow" v-for="(photography,index) in $store.state.top_members"
                :key="index">
                <div class="users">
                  <router-link :to="{name:'profile',params:{id:photography.id}}" class="user my-2 ">
                    <div class="animate__fadeInDown" :style="`animation-delay:.${index}s`">
                      <div class="d-flex justify-content-center mb-1 ">
                        <img v-if="photography.avatar!=null"
                          :src="`https://pic.imamhussain.org/avatars/medium/${photography.avatar}`" :alt="photography.name"
                          style="object-fit: cover;">
                        <img v-else :src="`https://ui-avatars.com/api/?name=${photography.name}&length=1&bold=true`"
                          :alt="photography.name" style="object-fit: cover;">
                      </div>
                      <div class="d-flex justify-content-center">
                        <h6 class="f-s">{{photography.name}}</h6>
                      </div>
                    </div>
                  </router-link>
                </div>
              </a>
            </nav>
    </div>
    
  </div>
</template>
<script>
  export default {
    data() {
      return {
        sliderActive: [],
        selectedSlide: 0,
        loader: true,
      }
    },
    props: {
      thumbs: {
        type: Boolean,
        default: false
      },
      autoPlay: {
        type: Boolean,
        default: true
      },
      autoPlayDelay: {
        type: Number,
        default: 5000
      },
    },
    created() {
      this.sliderActive = this.$store.state.gallery.todayPhoto[this.selectedSlide];
      this.$emit('change', this.sliderActive)
      if (this.autoPlay) {
        setInterval(() => {
          this.changeSlide()
        }, this.autoPlayDelay);
      }

    },
    computed: {
      todayImageInfo() {
        var dimensions = this.sliderActive.dimensions.split('x');
        var width = Number(dimensions[0])
        var height = Number(dimensions[1])
        return {
          width: width,
          height: height
        };
      }
    },
    methods: {
      changeSlide(slideIndex = null) {
        this.loader = false;
        if (slideIndex != null) {
          const slide = this.$store.state.gallery.todayPhoto[slideIndex];
          this.selectedSlide = slideIndex;
          this.sliderActive = slide;

          setTimeout(() => {
            this.loader = true
            this.$emit('change', this.sliderActive);
          }, 100);
          return;
        }
        for (let index = 0; index < this.$store.state.gallery.todayPhoto.length; index++) {
          const slide = this.$store.state.gallery.todayPhoto[index];
          if (index > this.selectedSlide) {
            this.selectedSlide = index;
            this.sliderActive = slide;

            setTimeout(() => {
              this.loader = true
              this.$emit('change', this.sliderActive);
            }, 100);

            break;
          } 

          if(index == Number(this.$store.state.gallery.todayPhoto.length)-1){
            this.selectedSlide = 0;
            this.sliderActive = this.$store.state.gallery.todayPhoto[0];

            setTimeout(() => {
              this.loader = true
              this.$emit('change', this.sliderActive);
            }, 100);
          }
        }

      }
    },
  }
</script>